import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiRoutes } from '../../../config/api-routes';
import { Issue } from '../model/issue';
import { PaginationResponse } from '../model/paginationResponse';
import { map } from 'rxjs/operators';
import { IssueLog } from '../model/issueLog';
import { catchError, tap } from 'rxjs/internal/operators';
import { IssueSearchParams } from '../model/issueSearchParams';
import { Multimedium } from '@npm.chapps.com/chapps.common.angular.library/lib/components/multimedium/model/multimedium';
import { ApplicationType } from '../enums/enums';

@Injectable()
export class IssuesService {
  defaultResponse: PaginationResponse<Issue> = { items: [], page: 0, total: 0 };
  issues$: BehaviorSubject<PaginationResponse<Issue>> = new BehaviorSubject<PaginationResponse<Issue>>(this.defaultResponse);
  resolved$: Subject<number[]> = new Subject<number[]>();
  updated$: Subject<Issue> = new Subject<Issue>();

  constructor(private httpClient: HttpClient, private config: ApiRoutes) {
  }

  public getIssue(issueGuid: string): Observable<Issue> {
    return this.httpClient.get<Issue>(
      ApiRoutes.getRouteWithInjectedParams(this.config.ISSUE_SUMMARY, [issueGuid])
    );
  }

  public getIssues(searchParams: IssueSearchParams): Observable<PaginationResponse<Issue>> {
    return this.httpClient.post<PaginationResponse<Issue>>(this.config.ISSUES, searchParams).pipe(
      tap(response => this.issues$.next(response)),
      catchError(() => of({ items: [], page: 0, total: 0 } as PaginationResponse<Issue>))
    );
  }

  public getLatestIssues(): Observable<Issue[]> {
    return this.getIssues({ pageNumber: 1, pageSize: 5, sortDirection: 'desc' }).pipe(
      map(issues => issues.items),
      catchError(() => of([]))
    );
  }

  getIssueLog(issueGuid: string) {
    return this.httpClient.get<IssueLog[]>(
      ApiRoutes.getRouteWithInjectedParams(this.config.ISSUE_LOGS, [issueGuid])).pipe(
        catchError(() => of([]))
      );
  }

  public getPhotos(issueGuid: string): Observable<Multimedium[]> {
    return this.httpClient.get<Multimedium[]>(
      ApiRoutes.getRouteWithInjectedParams(this.config.ISSUE_MEDIA, [issueGuid])
    ).pipe(
      catchError(() => of([]))
    );
  }

  public resolveIssue(issueGuid: string): Observable<any> {
    var route = ApiRoutes.getRouteWithInjectedParams(this.config.ISSUE_RESOLVE, [issueGuid]);
    return this.httpClient.post<any>(route, null).pipe(catchError(() => of({})));
  }
}
